import { SvgIcon } from "@mui/material";
import { IconProps } from "../_interface";

const TopicCommon = (props: IconProps) => {
  return(
    <SvgIcon {...props} color="inherit" viewBox="0 0 28 28">
      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14 24C19.5228 24 24 19.5228 24 14C24 8.47715 19.5228 4 14 4C8.47715 4 4 8.47715 4 14C4 19.5228 8.47715 24 14 24Z" stroke="#2E434D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M4 14H24" stroke="#2E434D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M14 4C16.5013 6.73835 17.9228 10.292 18 14C17.9228 17.708 16.5013 21.2616 14 24C11.4987 21.2616 10.0772 17.708 10 14C10.0772 10.292 11.4987 6.73835 14 4V4Z" stroke="#2E434D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </SvgIcon>
  );
}

export default TopicCommon;